import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

const headerAnimation = () => {


    const vw = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0);

if(vw > 576){
    if (document.querySelector('.kirinus-hero-wrapper')) {
        let floatyTl = gsap.timeline({repeat: -1, repeatDelay: 0});
        if(document.querySelector('.kirinus-hero--floaty-background')){
            const floatyBackground = document.querySelector('.kirinus-hero--floaty-background');
            const floatyHeight = floatyBackground.clientHeight;
            floatyTl.timeScale(0.1)
            floatyTl.fromTo('.kirinus-floaty-animation',{y: 0.2*floatyHeight },  {y: -1.25*floatyHeight, duration: 10, ease: "none",stagger: 0}, );
            floatyTl.fromTo('.kirinus-floaty-animation',{y: floatyHeight },  {y: -1.25*floatyHeight, duration: 10, ease: "none",stagger: 0.1}, '>-3');
            floatyTl.fromTo('.kirinus-floaty-animation',{y: floatyHeight },  {y: -1.25*floatyHeight, duration: 10, ease: "none",stagger: 0.1}, '>-2');

        }
        function offset(el) {
            let rect = el.getBoundingClientRect(),
                scrollLeft = window.pageXOffset || document.documentElement.scrollLeft,
                scrollTop = window.pageYOffset || document.documentElement.scrollTop;
            return { top: rect.top + scrollTop, left: rect.left + scrollLeft }
        }
        function XMovement(startleft, endleft, startWidth, endWidth, factor, word){
            let result  = 0;
            if(startleft > endleft){

                if(word === 1){
                    result = (startleft - endleft + (endWidth/4))*-1
                }else{
                    result = (startleft - endleft + (endWidth/6))*-1
                }

            } else{
                if(word === 1){
                    result = endleft - startleft - (endWidth/4);
                }else{
                    result = endleft - startleft - (endWidth/6);
                }


            }


            return result;
        }
        function YMovement(endtop, endheight, scrollContainerTop, starttop, startheight, factor){
            let result = (endtop  - scrollContainerTop) - (starttop + ((startheight*factor)/4) ) // + ((startheight*factor)/4) if scaled

            return result
        }



        const scrollOverContainer = document.querySelector('.kirinus-scroll-over');


        let scrollOverContainerTop = offset(scrollOverContainer).top;

        let scrollHeight = scrollOverContainerTop;


        let factor = 0.67;


        let targetWordOne = document.querySelector('.target-word-1');

        let startWordOne = document.getElementById('hero-first-word');


        //  Movement Word One







        let startOneObj = offset(startWordOne);
        let endOneObj = offset(targetWordOne);
        let wordOneMoveBy = YMovement(endOneObj.top, targetWordOne.clientHeight, scrollOverContainerTop,startOneObj.top,  startWordOne.clientHeight, factor );
        let wordOneMoveXBy = XMovement(startOneObj.left, endOneObj.left, startWordOne.getBoundingClientRect().width, targetWordOne.getBoundingClientRect().width, factor, 1);
        //wordOneMoveXBy = 0;



        // Word 2
        let targetWordTwo = document.querySelector('.target-word-2');

        let startWordTwo = document.getElementById('hero-second-word');

        //  Movement Word Two
        let startTwoObj = offset(startWordTwo);
        let endTwoObj = offset(targetWordTwo);


        let wordTwoMoveBy = YMovement(endTwoObj.top, targetWordTwo.clientHeight, scrollOverContainerTop,startTwoObj.top,  startWordTwo.clientHeight, factor );
        let wordTwoMoveXBy = XMovement(startTwoObj.left, endTwoObj.left, startWordTwo.clientWidth, targetWordTwo.clientWidth, factor, 2);










        let tl = gsap.timeline({
            scrollTrigger: {
                trigger: '.kirinus-hero-wrapper',
                pin: true,
                anticipatePin: 1,
                start: 'top top',
                end: 'bottom top',
                //toggleActions: 'restart pause reverse reset',
                //markers: true,
                scrub: 2,
                snap:  {
                    snapTo: "labelsDirectional", // snap to the closest label in the timeline
                    duration: {min: 0.2, max: 2.5}, // the snap animation should be at least 0.2 seconds, but no more than 3 seconds (determined by velocity)
                    delay: 0.2, // wait 0.2 seconds from the last scroll event before doing the snapping
                    ease: 'none',
                  /*  onStart: self => {console.log('snap start')},
                    onInterrupt: self => {console.log('snap interrupted')},
                    onComplete: self => {console.log('snap complete')},*/
                },
            }
        })

        tl.timeScale( 1 );
        tl.addLabel('start');

        tl.to('.kirinus-floaty-animation', {
            y: -scrollHeight,
            // stagger: 0.2,
            ease: 'none',
            duration: 2,

        }, 1);
        tl.add(function(){

            if(floatyTl.paused()){
                floatyTl.play()
            }else{
                floatyTl.pause()
            }
        }, '>-2')
        tl.to('.kirinus-hero-disappear', {opacity: 0, duration: 1.5 } );
        tl.to('.kirinus-floaty-animation', {
            opacity: 0,
            duration: 2,

        },'>-3.5' );






        tl.to(
            '.kirinus-scroll-over', {y: -scrollHeight, duration: 1},
        )
        tl.fromTo('#hero-first-word', {scale: 1}, {scale: factor, duration: 2,  ease: 'power2',}, ">-1")

        tl.fromTo('#hero-first-word', {x: 0, y: 0.02},{
            x: wordOneMoveXBy,
            y: wordOneMoveBy,
            duration: 2,
            ease: 'power2',
        }, ">-1");
        tl.fromTo('#hero-second-word', {scale: 1}, {scale: factor, duration: 2,  ease: 'power2'}, ">-2")
        tl.fromTo('#hero-second-word', {x: 0, y: 0.02},{
            x: wordTwoMoveXBy,
            y: wordTwoMoveBy,
            duration: 2,
            ease: 'power2',
        }, ">-2" );
        tl.addLabel('end');
        tl.to({}, {duration: 2});



    }
}

}
export default headerAnimation;